// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

const performanceDashboard = (state) =>
  get(state, ['dashboard', 'performanceDashboard'], {})

export const performanceDashboardGeneralInfo$ = createSelector(
  performanceDashboard,
  ({ performanceDashboardGeneralInfo = {} }) => performanceDashboardGeneralInfo
)

export const performanceDashboardCaseManagers$ = createSelector(
  performanceDashboard,
  ({ performanceDashboardCaseManagers = [] }) =>
    performanceDashboardCaseManagers
)
